module.exports = __webpack_public_path__ + "static/media/an.6005141f.svg";